import { supabase } from "@/integrations/supabase/client";

export type ActivityType = 'view' | 'favorite' | 'unfavorite' | 'compare' | 'share';

interface TrackActivityParams {
  userId: string;
  productId: string;
  activityType: ActivityType;
  durationSeconds?: number;
  metadata?: Record<string, any>;
}

export async function trackBrowsingActivity({
  userId,
  productId,
  activityType,
  durationSeconds,
  metadata = {},
}: TrackActivityParams) {
  const { error } = await supabase
    .from('agent_browsing_activity')
    .insert({
      user_id: userId,
      product_id: productId,
      activity_type: activityType,
      duration_seconds: durationSeconds,
      metadata,
    });

  if (error) {
    console.error('Error tracking browsing activity:', error);
    throw error;
  }
}

export async function getBrowsingActivity(userId: string, limit = 50) {
  const { data, error } = await supabase
    .from('agent_browsing_activity')
    .select(`
      *,
      products (
        id,
        slug,
        title,
        categories
      )
    `)
    .eq('user_id', userId)
    .order('created_at', { ascending: false })
    .limit(limit);

  if (error) {
    console.error('Error fetching browsing activity:', error);
    throw error;
  }

  return data;
}

export async function getRecentlyViewed(userId: string, limit = 10) {
  const { data, error } = await supabase
    .from('agent_browsing_activity')
    .select(`
      *,
      products (
        id,
        slug,
        title,
        image,
        price,
        rating
      )
    `)
    .eq('user_id', userId)
    .eq('activity_type', 'view')
    .order('created_at', { ascending: false })
    .limit(limit);

  if (error) {
    console.error('Error fetching recently viewed:', error);
    throw error;
  }

  // Deduplicate by product_id, keeping most recent
  const uniqueProducts = data?.reduce((acc: any[], curr) => {
    if (!acc.find(item => item.product_id === curr.product_id)) {
      acc.push(curr);
    }
    return acc;
  }, []);

  return uniqueProducts;
}
